import { useTranslation } from '@eti/providers';
import { Badge, Inline, Text, textVariants, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { SealCheck } from '@phosphor-icons/react';

const tripTagTitleStyles = css`
  background-color: ${vars.colors.promotional.foreground};
  border-radius: 8px;
  color: ${vars.colors.promotional.background};
  padding: 4px 8px;
`;

const PreferredCarrierTag = () => {
  const { t } = useTranslation();

  return (
    <Badge className={tripTagTitleStyles}>
      <Inline spacing={4}>
        <SealCheck color={vars.colors.promotional.background} size="20px" weight="fill" />
        <Text variant={textVariants._14_BOLD}>
          {t('Result.Page.ResultCard.PreferredCarrier.Badge.Text')}
        </Text>
      </Inline>
    </Badge>
  );
};

export default PreferredCarrierTag;
